export default "__VITE_ASSET__B9jGe9NV__"